import { render } from "./Record_list.vue?vue&type=template&id=4fe89a19&scoped=true"
import script from "./Record_list.vue?vue&type=script&lang=js"
export * from "./Record_list.vue?vue&type=script&lang=js"

import "./Record_list.vue?vue&type=style&index=0&id=4fe89a19&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe89a19"]])

export default __exports__